import { useQuery } from '@tanstack/react-query'

import { getEarliestExpiringGuaranteeMoneyForOrganization } from '@src/api'
import { DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchEarliestExpiringGuaranteeMoneyForOrganization = (
  params: DefaultApiGetEarliestExpiringGuaranteeMoneyForOrganizationRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () =>
      getEarliestExpiringGuaranteeMoneyForOrganization(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_EARLIEST_EXPIRING_GUARANTEE_MONEY_FOR_ORGANIZATION,
    ],
  })
}
